import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-389fe4c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "学歴を教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "最終学歴からご入力ください", -1))
const _hoisted_5 = { class: "entry_career_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "卒業区分"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_7 = { class: "entry_career_input_layout_column_2" }
const _hoisted_8 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_9 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_10 = { class: "entry_career_education_title" }
const _hoisted_11 = { class: "entry_career_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "学校情報"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_13 = { class: "entry_career_input_layout_column_1" }
const _hoisted_14 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_15 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_16 = { class: "entry_career_input" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "入学年月"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_18 = { class: "entry_career_input_layout_column_2" }
const _hoisted_19 = { class: "entry_career_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "卒業年月"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_21 = { class: "entry_career_input_layout_column_2" }
const _hoisted_22 = {
  key: 0,
  class: "entry_career_education_delete"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "entry_career_education_add" }
const _hoisted_25 = { class: "entry_career_button" }
const _hoisted_26 = { class: "entry_career_button_prev" }
const _hoisted_27 = { class: "entry_career_button_next" }

import { ref, Ref, computed } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import BaseYmForm from '@/components/BaseYmForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Indicator from '@/components/Indicator.vue';
import Loading from '@/components/Loading.vue';
import { getAcademicInfo, putAcademicInfo } from '@/api/careersheetEndpoint';
import { getMasterDataListLstSchl, getMasterDataListEntrance, getMasterDataListGrad } from '@/api/masterDataEndpoint';
import { useRouter } from 'vue-router';
import { validationRuleHelper } from '@/utils/validationRule';
import { useField, useForm, useFieldArray } from 'vee-validate';
import { object, string, array, number } from 'yup';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { EducationItem, SchoolHistoryInfoItem } from '@/types';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'EducationView',
  setup(__props) {

const schema = object({
  education: array()
    .of(
      object().shape({
        schlname: string().label('学校名').required(VALIDATON_ERRORS.REQUIRED).max(70, VALIDATON_ERRORS.MAX_LENGTH),
        schldeptname: string().label('学部名').max(35, VALIDATON_ERRORS.MAX_LENGTH),
        entranceYm: string().label('入学年月').required(VALIDATON_ERRORS.REQUIRED),
        entranceFlg: number().nullable().label('入学/編入').required(VALIDATON_ERRORS.REQUIRED),
        gradYm: string().label('卒業年月').required(VALIDATON_ERRORS.REQUIRED),
        gradFlg: number().nullable().label('卒業/中退').required(VALIDATON_ERRORS.REQUIRED),
      })
    )
    .strict(),
});

let index = 0;
const defaultEducationItem: EducationItem = {
  index,
  schlname: '',
  schldeptname: '',
  entranceYm: '',
  entranceFlg: null,
  gradYm: '',
  gradFlg: null,
};

const { errors } = useForm({
  validationSchema: schema,
});

const schlErrors = (index: number, formName: string) => {
  const error = errors.value[`education[${index}].${formName}`];
  return error !== undefined ? [error] : [];
};

const {
  remove: educationRemove,
  replace: educationReplace,
  push: educationPush,
  fields: education,
} = useFieldArray<EducationItem>('education');

const router = useRouter();
const isLoading = ref(false);
const init = async () => {
  isLoading.value = true;
  try {
    const [academicInfo, mstLstSchl, mstEntrance, mstGrad] = await Promise.all([
      getAcademicInfo(),
      getMasterDataListLstSchl(),
      getMasterDataListEntrance(),
      getMasterDataListGrad(),
    ]);
    lstschlId.value = academicInfo.lstschlId;
    scienceFlg.value = academicInfo.scienceFlg || false;
    schoolHistoryInfoList.value = academicInfo.schoolHistoryInfoList;

    if (schoolHistoryInfoList.value.length < 1) {
      index++;
      educationPush({ ...defaultEducationItem, index });
    } else {
      const education = schoolHistoryInfoList.value
        .map((item) => {
          index++;
          return {
            index,
            schlname: item.schlname || '',
            schldeptname: item.schldeptname || '',
            entranceYm: `${item.entranceyr}-${String(item.entrancemon).padStart(2, '0')}`,
            entranceFlg: item.entranceFlg,
            gradYm: `${item.gradyr}-${String(item.gradmon).padStart(2, '0')}`,
            gradFlg: item.gradFlg,
          };
        })
        .filter((i) => i.index <= 4);
      educationReplace(education);
    }

    graduationCategoryOptions.value = mstLstSchl.map((i) => {
      return { label: i.name, value: i.code };
    });
    entranceOptions.value = mstEntrance.map((i) => {
      return { label: i.name, value: i.code };
    });
    gradOptions.value = mstGrad.map((i) => {
      return { label: i.name, value: i.code };
    });
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const entranceOptions: Ref<Options> = ref([]);
const gradOptions: Ref<Options> = ref([]);

const { value: lstschlId, errors: lstschlIdErrors } = useField<number | null>('lstschlId', validationRuleHelper({ required: true }), {
  initialValue: null,
  bails: false,
  label: '卒業区分',
});
const graduationCategoryOptions: Ref<Options> = ref([]);

const { value: scienceFlg, errors: scienceFlgErrors } = useField<boolean | null>('scienceFlg', validationRuleHelper({ required: true }), {
  initialValue: false,
  bails: false,
  label: '卒業区分',
});

const lstschlErrors = computed(() => {
  if (lstschlIdErrors.value.length > 0) return lstschlIdErrors.value;
  return scienceFlgErrors.value;
});

const schoolHistoryInfoList: Ref<SchoolHistoryInfoItem[]> = ref([]);
const newSchoolHistoryInfoList: Ref<SchoolHistoryInfoItem[]> = computed(() => {
  return education.value.map((item) => {
    return {
      schlname: item.value.schlname || '',
      schldeptname: item.value.schldeptname || '',
      entranceyr: item.value.entranceYm.split('-')[0] || '',
      entrancemon: item.value.entranceYm.split('-')[1] || '',
      entranceFlg: item.value.entranceFlg,
      gradyr: item.value.gradYm.split('-')[0] || '',
      gradmon: item.value.gradYm.split('-')[1] || '',
      gradFlg: item.value.gradFlg,
    };
  });
});

const deleteEducation = (id: number) => {
  if (education.value.length <= 1) {
    return;
  }
  const index = education.value.findIndex((i) => i.value.index === id);
  if (index > -1) {
    delete errors.value[`education[${index}].entranceFlg`];
    delete errors.value[`education[${index}].entranceYm`];
    delete errors.value[`education[${index}].gradFlg`];
    delete errors.value[`education[${index}].gradYm`];
    delete errors.value[`education[${index}].schldeptname`];
    delete errors.value[`education[${index}].schlname`];
    educationRemove(index);
  }
};

const addEducation = () => {
  index++;
  educationPush({ ...defaultEducationItem, index });
};

const isSchoolHistoryError = computed(() => {
  return newSchoolHistoryInfoList.value.some((i) => {
    return !i.entranceFlg || !i.entrancemon || !i.entranceyr || !i.gradFlg || !i.gradmon || !i.gradyr || !i.schlname;
  });
});

// 保存して次へボタン押下
const save = async () => {
  // apiに送信する
  isLoading.value = true;
  try {
    await putAcademicInfo({
      lstschlId: lstschlId.value,
      scienceFlg: scienceFlg.value || false,
      schoolHistoryInfoList: newSchoolHistoryInfoList.value,
    });
    router.push({ name: 'c02' });
  } catch (error) {
    console.error(error);
  } finally {
    // 何もしない
  }
  isLoading.value = false;
};

const transitionPreviousPage = () => {
  router.push({ name: 'c00' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 2,
          max: 12
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseSelectBox, {
              modelValue: _unref(lstschlId),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lstschlId) ? (lstschlId).value = $event : null)),
              placeholder: "卒業区分を選択",
              options: graduationCategoryOptions.value
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BaseCheckbox, {
              value: true,
              modelValue: _unref(scienceFlg),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(scienceFlg) ? (scienceFlg).value = $event : null)),
              label: "理系"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(lstschlErrors) }, null, 8, ["errors"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(education), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "entry_career_education",
          key: item.value.index
        }, [
          _createElementVNode("div", _hoisted_10, "学歴" + _toDisplayString(index + 1), 1),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(BaseTextForm, {
                  placeholder: "学校名",
                  modelValue: item.value.schlname,
                  "onUpdate:modelValue": ($event: any) => ((item.value.schlname) = $event),
                  isError: schlErrors(index, 'schlname').length > 0,
                  maxlength: 70
                }, null, 8, ["modelValue", "onUpdate:modelValue", "isError"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(BaseTextForm, {
                  placeholder: "学部名",
                  modelValue: item.value.schldeptname,
                  "onUpdate:modelValue": ($event: any) => ((item.value.schldeptname) = $event),
                  isError: schlErrors(index, 'schldeptname').length > 0,
                  maxlength: 35
                }, null, 8, ["modelValue", "onUpdate:modelValue", "isError"])
              ])
            ]),
            _createVNode(ErrorMessage, {
              errors: schlErrors(index, 'schlname')
            }, null, 8, ["errors"]),
            _createVNode(ErrorMessage, {
              errors: schlErrors(index, 'schldeptname')
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(BaseYmForm, {
              modelValue: item.value.entranceYm,
              "onUpdate:modelValue": ($event: any) => ((item.value.entranceYm) = $event),
              placeholder: "2010-01",
              yearSort: "desc"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entranceOptions.value, (entranceOption) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "entry_career_input_layout_column_2_item",
                  key: entranceOption.value
                }, [
                  _createVNode(BaseRadioButton, {
                    label: entranceOption.label,
                    name: `admisssion${item.value.index}`,
                    value: entranceOption.value,
                    modelValue: item.value.entranceFlg,
                    "onUpdate:modelValue": ($event: any) => ((item.value.entranceFlg) = $event)
                  }, null, 8, ["label", "name", "value", "modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ])
          ]),
          _createVNode(ErrorMessage, {
            errors: schlErrors(index, 'entranceYm')
          }, null, 8, ["errors"]),
          _createVNode(ErrorMessage, {
            errors: schlErrors(index, 'entranceFlg')
          }, null, 8, ["errors"]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(BaseYmForm, {
              modelValue: item.value.gradYm,
              "onUpdate:modelValue": ($event: any) => ((item.value.gradYm) = $event),
              placeholder: "2010-01",
              yearSort: "desc"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradOptions.value, (gradOption) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "entry_career_input_layout_column_2_item",
                  key: gradOption.value
                }, [
                  _createVNode(BaseRadioButton, {
                    label: gradOption.label,
                    name: `graduation${item.value.index}`,
                    value: gradOption.value,
                    modelValue: item.value.gradFlg,
                    "onUpdate:modelValue": ($event: any) => ((item.value.gradFlg) = $event)
                  }, null, 8, ["label", "name", "value", "modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ]),
            _createVNode(ErrorMessage, {
              errors: schlErrors(index, 'gradYm')
            }, null, 8, ["errors"]),
            _createVNode(ErrorMessage, {
              errors: schlErrors(index, 'gradFlg')
            }, null, 8, ["errors"]),
            (index > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("button", {
                    class: "button_education_delete",
                    onClick: ($event: any) => (deleteEducation(item.value.index))
                  }, "学歴" + _toDisplayString(index + 1) + "を削除", 9, _hoisted_23)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(BaseButton, {
          theme: "secondary",
          type: "button",
          onClick: addEducation,
          disabled: _unref(education).length >= 4
        }, {
          default: _withCtx(() => [
            _createTextVNode(" ＋学歴を追加する（4つまで） ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(BaseButton, {
            theme: "tertiary",
            type: "button",
            onClick: transitionPreviousPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(BaseButton, {
            theme: "primary",
            disabled: _unref(isSchoolHistoryError) || _unref(lstschlErrors).length > 0,
            type: "button",
            onClick: save
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存して次へ ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})